import {
  FlatList,
  Image,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  Modal,
  TextInput,
  Dimensions,
  TouchableWithoutFeedback,
  Pressable,
} from "react-native";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AppColors from "../../Constants/AppColors";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";
// import { useTranslation } from "react-i18next";
import { VehicleAccident, VehicleList } from "../../Constants/Data";
const { width, height } = Dimensions.get("window");
const VehicleExpenseOp = ({ navigation }) => {
  const [Modalvisible3, setModalvisible3] = useState(false);
  const [DotModal, setDotModal] = useState(false);

  // Auto-open the "Delete" confirmation modal on its PDF route.
  const location = useLocation();
  useEffect(() => {
    if (
      location.pathname ===
      "/VehicleExpenses/VehicleAccident/VehicleAccidentRemove/Delete"
    ) {
      setModalvisible3(true);
    }
  }, [location.pathname]);
  // const { t } = useTranslation(["common"]);
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };
  //---------Search Text Input---------//
  const VehicleAccident = [
    {
      id: 1,
      img: AppImages.yellowcar,
      H1: "Vehicle Name",
      H2: "Toyoto Innova",
      H3: "Trip Name",
      H4: "Location",
      H5: "Mr John Doe",
      H6: "Pune",
      H7: "Expenses",
      H8: "Date",
      H9: "Rs 5000",
      H10: "18-02-2023",
      Dot: AppImages.Threedots,
    },
    {
      id: 2,
      img: AppImages.bluecar,
      H1: "Vehicle Name",
      H2: "Toyoto Innova",
      H3: "Trip Name",
      H4: "Location",
      H5: "Mr John Doe",
      H6: "Pune",
      H7: "Expenses",
      H8: "Date",
      H9: "Rs 5000",
      H10: "18-02-2023",
      Dot: AppImages.Threedots,
    },
    {
      id: 3,
      img: AppImages.Bike,
      H1: "Vehicle Name",
      H2: "Honda Bike",
      H3: "Trip Name",
      H4: "Location",
      H5: "Mr John Doe",
      H6: "Pune",
      H7: "Expenses",
      H8: "Date",
      H9: "Rs 5000",
      H10: "18-02-2023",
      Dot: AppImages.Threedots,
    },
    {
      id: 4,
      img: AppImages.blackcar,
      H1: "Vehicle Name",
      H2: "Toyoto Innova",
      H3: "Trip Name",
      H4: "Location",
      H5: "Mr John Doe",
      H6: "Pune",
      H7: "Expenses",
      H8: "Date",
      H9: "Rs 5000",
      H10: "18-02-2023",
      Dot: AppImages.Threedots,
    },
    {
      id: 5,
      img: AppImages.redcar,
      H1: "Vehicle Name",
      H2: "Toyoto Innova",
      H3: "Trip Name",
      H4: "Location",
      H5: "Mr John Doe",
      H6: "Pune",
      H7: "Expenses",
      H8: "Date",
      H9: "Rs 5000",
      H10: "18-02-2023",
      Dot: AppImages.Threedots,
    },
    {
      id: 6,
      img: AppImages.yellowcar,
      H1: "Vehicle Name",
      H2: "Toyoto Innova",
      H3: "Trip Name",
      H4: "Location",
      H5: "Mr John Doe",
      H6: "Pune",
      H7: "Expenses",
      H8: "Date",
      H9: "Rs 5000",
      H10: "18-02-2023",
      Dot: AppImages.Threedots,
    },
  ];
  const [selectedItem, setSelectedItem] = useState(null);
  const [data, setData] = useState(VehicleAccident);
  const [searchText, setSearchText] = useState(""); // State for search input
  const handleSearch = (text) => {
    setSearchText(text);
    // Implement search logic here to filter the data based on the entered text
    const filteredData = VehicleAccident.filter((item) =>
      item.H2.toLowerCase().includes(text.toLowerCase())
    );
    setData(filteredData);
  };
  const [activeIndex, setActiveIndex] = useState(1);
  const handleTextPress = (index) => {
    setActiveIndex(index);
  };
  //-------Del FlatList ---------//
  const handleThreeDotPress = (item) => {
    setSelectedItem(item);
    setDotModal(true);
  };
  const handleDeleteConfirmation = () => {
    setDotModal(false);
    setModalvisible3(true);
  };

  const handleDelete = (itemToDelete) => {
    const updatedData = data.filter((item) => item !== itemToDelete);
    setData(updatedData);
    setModalvisible3(false);
    setSelectedItem(null);
  };
  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.white }}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: AppColors.white,
          height: 58,
          justifyContent: "space-between",
          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 10 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TouchableOpacity
            style={{ height: 30, width: 30, justifyContent: "center" }}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15 }}
            />
          </TouchableOpacity>
          <Text
            style={{
              fontSize: 16,
              fontFamily: AppFonts.OverpassMedium,

              color: AppColors.brown1,
            }}
          >
            Vehicle Accident
          </Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={{ width: 16, height: 20 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => navigation.navigate("AddVehicleIncident")}
          >
            <Image
              source={AppImages.Plus}
              style={{ width: 18, height: 18, marginLeft: 20 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>
      <View style={{ backgroundColor: AppColors.sandal, flex: 1 }}>
        <View style={styles.SecMain}>
          <View style={{ marginHorizontal: 20 }}>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  width: "82%",
                  height: 40,
                  borderRadius: 10,
                  justifyContent: "space-between",
                  backgroundColor: "#ffffff",
                  borderWidth: 1,
                  borderColor: "#F6EFE9",
                  marginTop: 15,
                  marginBottom: 15,
                }}
              >
                <TextInput
                  style={{
                    paddingLeft: 10,
                    color: AppColors.brown2,
                    width: "80%",
                  }}
                  placeholder="Search Vehicle... "
                  placeholderTextColor={"#AAAAAA"}
                  editable={true}
                  autoCapitalize="none"
                  value={searchText} // Bind search input value to state
                  onChangeText={handleSearch}
                />
                <View
                  style={{
                    alignItems: "flex-end",
                    justifyContent: "center",
                    flex: 1,
                  }}
                >
                  <Image
                    source={AppImages.search}
                    style={{ width: 19, height: 18, marginRight: 20 }}
                  />
                </View>
              </View>

              <View style={styles.ExImport}>
                <Image
                  source={AppImages.Import}
                  style={styles.ims}
                  resizeMode="contain"
                />

                <Image
                  source={AppImages.Shareit}
                  style={styles.ha}
                  resizeMode="contain"
                />
              </View>
            </View>

            <FlatList
              showsVerticalScrollIndicator={false}
              ListFooterComponent={() => <View style={{ padding: 80 }} />}
              data={data}
              renderItem={({ item }) => (
                <TouchableOpacity
                  style={styles.Flatmain}
                  onPress={() => navigation.navigate("VehicleincidentDetail")}
                >
                  <View style={styles.FlatmainSec}>
                    <View style={styles.FlatImg}>
                      <View style={{ flexDirection: "row" }}>
                        <Image
                          source={item.img}
                          style={{ width: 35, height: 66 }}
                          resizeMode="contain"
                        />
                        <View style={styles.FlatTxt}>
                          <Text style={styles.FlatTxtSec}>
                            {t("common:translation.Vehicle Name")}
                          </Text>
                          <Text style={styles.CopyTextSe}>{item.H2}</Text>
                        </View>
                      </View>
                      <TouchableOpacity
                        onPress={() => handleThreeDotPress(item)}
                        style={{
                          width: 25,
                          height: 25,
                          marginTop: 10,
                          alignItems: "flex-end",
                        }}
                      >
                        <Image
                          source={item.Dot}
                          style={styles.iamge}
                          resizeMode="contain"
                        />
                      </TouchableOpacity>
                    </View>
                    <View style={{}}>
                      <View style={styles.LineBars}></View>
                    </View>
                    <View style={{}}>
                      <View style={{}}>
                        <View style={styles.Row}>
                          <Text style={styles.Textt}>
                            {t("common:translation.Driver Name")}
                          </Text>
                          <Text style={styles.TextTwo}>
                            {t("common:translation.Location")}
                          </Text>
                        </View>
                        <View style={styles.Row}>
                          <Text style={styles.CopyTextSec}>{item.H5}</Text>
                          <Text style={styles.CopyText}>{item.H6}</Text>
                        </View>
                        <View style={styles.Row}>
                          <Text style={styles.Textt}>
                            {t("common:translation.Expenses")}
                          </Text>
                          <Text style={styles.TextTwo}>
                            {t("common:translation.Date")}
                          </Text>
                        </View>

                        <View style={styles.Row}>
                          <Text style={styles.CopyTextSec}>{item.H9}</Text>
                          <Text style={styles.CopyText}>{item.H10}</Text>
                        </View>
                      </View>
                    </View>
                  </View>
                </TouchableOpacity>
              )}
            />
          </View>
          <Modal
            animationType="slide"
            visible={DotModal}
            onRequestClose={() => {
              setDotModal(false);
            }}
            transparent={true}
          >
            <TouchableWithoutFeedback onPress={() => setDotModal(false)}>
              <View
                style={{ backgroundColor: AppColors.ModalColor, flex: 1 }}
              ></View>
            </TouchableWithoutFeedback>
            <View
              style={{
                width: "100%",
                backgroundColor: "white",

                borderTopRightRadius: 16,
                borderTopLeftRadius: 16,
                position: "absolute",
                bottom: 0,
                padding: 20,
              }}
            >
              <TouchableOpacity
                style={{ justifyContent: "center", alignItems: "center" }}
              >
                <Image
                  source={AppImages.LineBar}
                  style={{ width: "15%", height: 2 }}
                />
              </TouchableOpacity>

              <TouchableWithoutFeedback
                style={{
                  marginTop: 20,
                  flexDirection: "row",
                }}
                onPress={() => [
                  setDotModal(false),
                  navigation.navigate("VehicleincidentDetail"),
                  handleTextPress(1),
                ]}
              >
                <View
                  style={{
                    marginLeft: 10,
                  }}
                >
                  <Text
                    style={[
                      styles.text,
                      activeIndex === 1 && styles.activeText,
                    ]}
                  >
                    View
                  </Text>
                </View>
              </TouchableWithoutFeedback>
              <TouchableWithoutFeedback
                style={{
                  marginTop: 20,
                  flexDirection: "row",
                }}
                onPress={() => [
                  setDotModal(false),
                  navigation.navigate("EditVehicleIncident"),
                  handleTextPress(2),
                ]}
              >
                <View
                  style={{
                    marginLeft: 10,
                  }}
                >
                  <Text
                    style={[
                      styles.text,
                      activeIndex === 2 && styles.activeText,
                    ]}
                  >
                    Edit
                  </Text>
                </View>
              </TouchableWithoutFeedback>

              <TouchableWithoutFeedback
                style={{
                  marginTop: 20,
                  flexDirection: "row",
                }}
                onPress={() => [handleDeleteConfirmation(), handleTextPress(3)]}
              >
                <View
                  style={{
                    marginLeft: 10,
                  }}
                >
                  <Text
                    style={[
                      styles.text,
                      activeIndex === 3 && styles.activeText,
                    ]}
                  >
                    Delete
                  </Text>
                </View>
              </TouchableWithoutFeedback>
            </View>
          </Modal>

          <Modal
            animationType="slide"
            transparent={true}
            visible={Modalvisible3}
            onRequestClose={() => {
              setModalvisible3(!Modalvisible3);
            }}
          >
            <Pressable
              onPress={() => setModalvisible3(true)}
              style={{
                flex: 1,
                backgroundColor: AppColors.ModalColor,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <View
                style={{
                  backgroundColor: AppColors.white,
                  width: "90%",
                  padding: 20,
                  borderRadius: 15,
                  margin: 20,
                }}
              >
                <View style={{}}>
                  <TouchableOpacity>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontFamily: AppFonts.OverpassRegular,
                          fontSize: 20,
                        }}
                      >
                        Delete
                      </Text>
                      <TouchableOpacity onPress={() => setModalvisible3(false)}>
                        <Image
                          source={AppImages.Delpic}
                          style={{ height: 14, width: 12 }}
                        />
                      </TouchableOpacity>
                    </View>
                  </TouchableOpacity>
                  <View
                    style={{
                      borderWidth: 0.4,
                      borderColor: AppColors.brown1,
                      opacity: 0.099,
                      marginTop: 10,
                      marginBottom: 10,
                      alignItems: "center",
                    }}
                  ></View>

                  <Text
                    style={{
                      color: AppColors.brown,
                      fontFamily: AppFonts.OverpassRegular,
                      fontSize: 14,
                      width: "100%",
                    }}
                  >
                    Are you sure you want to Delete Vehicle Accident ?
                  </Text>
                  <View
                    style={{
                      borderWidth: 0.4,
                      borderColor: AppColors.brown1,
                      opacity: 0.099,
                      marginTop: 10,
                      marginBottom: 10,
                      alignItems: "center",
                    }}
                  ></View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                      marginTop: 10,
                    }}
                  >
                    <TouchableOpacity
                      onPress={() => setModalvisible3(false)}
                      style={{
                        width: "30%",
                        height: 35,
                        borderColor: AppColors.brown,
                        borderWidth: 1,
                        borderRadius: 10,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.brown,
                          fontFamily: AppFonts.OverpassSemiBold,
                          fontSize: 14,
                        }}
                      >
                        Cancel
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={() => handleDelete(selectedItem)}
                      style={{
                        width: "30%",
                        height: 35,
                        backgroundColor: AppColors.brown,
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 10,
                        marginLeft: 20,
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.white,
                          fontFamily: AppFonts.OverpassSemiBold,
                          fontSize: 14,
                        }}
                      >
                        Yes
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
            </Pressable>
          </Modal>
        </View>
      </View>
    </SafeAreaView>
  );
};

export default VehicleExpenseOp;

const styles = StyleSheet.create({
  SecMain: { marginTop: 20, backgroundColor: AppColors.white },
  TExtinputView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    // backgroundColor:"aqua",
    width: "100%",
    marginBottom: 10,
    marginTop: 20,

    // height: height * 0.04,
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,
    width: "80%",
    borderRadius: 10,
    borderColor: AppColors.sandal,
    // height: height * 0.05,
    borderWidth: 1,
    paddingLeft: 20,
    flexDirection: "row",

    borderRadius: 8,
    justifyContent: "space-between",

    shadowColor: "#000001A",
    shadowOffset: { width: 1, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 1,
    // elevation: 6,
  },
  ExImport: {
    flexDirection: "row",

    alignItems: "center",
    justifyContent: "center",
    marginTop: 5,
  },
  Flatmain: {
    marginBottom: 20,
    // backgroundColor:"red",
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
  },
  FlatmainSec: {
    margin: 10,
    marginLeft: 10,
    paddingVertical: 10,
    paddingHorizontal: 10,
  },
  FlatImg: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  FlatTxt: { justifyContent: "center", marginLeft: 20 },
  FlatTxtSec: {
    // marginTop: 5,
    fontSize: 12,
    opacity: 0.6,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  FlatTxtT2: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  LineBars: {
    width: "100%",
    right: 20,
    borderTopColor: AppColors.brown,
    borderTopWidth: 0.7,
    opacity: 0.099,
    marginTop: 10,
    marginBottom: 10,
  },
  CopyText: {
    fontSize: 14,
    marginTop: 5,

    fontFamily: AppFonts.OverpassSemiBold,
    color: AppColors.brown1,
  },
  CopyTextSec: {
    width: "50%",
    fontSize: 14,
    marginTop: 5,
    fontFamily: AppFonts.OverpassSemiBold,
    color: AppColors.brown1,
  },
  CopyTextSe: {
    fontSize: 12,
    marginTop: 5,
    fontFamily: AppFonts.OverpassSemiBold,
    color: AppColors.brown1,
  },
  NonCopy: {
    width: width * 0.4,
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },
  Row: { flexDirection: "row", flex: 1 },

  Textt: {
    width: "50%",
    marginTop: 10,
    fontSize: 12,
    opacity: 0.6,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },

  TextTwo: {
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
    opacity: 0.6,
  },
  //--------modal Del
  hox: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  presss: {
    width: "40%",
    marginHorizontal: 10,
  },
  //-------cancel  btn---//
  sty: {
    flexDirection: "row",
    marginVertical: 10,
  },
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    padding: 5,
    width: "100%",
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  lins: {
    borderTopWidth: 1,
    width: "100%",
    // right: 20,
    borderTopColor: AppColors.sandal,
    marginTop: 20,
  },
  vee: {
    alignItems: "flex-end",
    justifyContent: "center",
    flex: 1,
  },
  im: { width: 20, height: 20, marginRight: 30 },
  too: { alignSelf: "flex-end", justifyContent: "center" },
  ims: { width: 22, height: 22 },
  ha: { width: 22, height: 22, marginLeft: 10 },
  iamge: { width: 3, height: 18, alignItems: "center", marginRight: 5 },
  feed: { backgroundColor: AppColors.FeedBack, flex: 1, opacity: 0.55 },
  viww: {
    width: "100%",
    backgroundColor: "white",

    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
    position: "absolute",
    bottom: 0,
    padding: 20,
  },
  hsh: { justifyContent: "center", alignItems: "center" },
  jns: { width: "15%", height: 2 },
  yooo: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
  ttxt: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 14,
    color: AppColors.brown1,
  },
  fffsf: {
    marginTop: 20,
    flexDirection: "row",
  },
  modo: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.brown1,
  },
  presse: {
    flex: 1,
    backgroundColor: AppColors.BLUR_BG,
    alignItems: "center",
    justifyContent: "center",
  },
  dsdd: {
    backgroundColor: "white",
    borderRadius: 20,
    marginHorizontal: 20,
    width: "80%",
    paddingTop: 15,
  },
  sss: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
  },
  fd: { flexDirection: "row", alignItems: "center" },
  hbh: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 20,
    lineheight: 25.32,
    color: AppColors.brown1,
  },
  hhsj: { width: 24, height: 24 },
  fasfd: { marginTop: 20, marginHorizontal: 20 },
  sdsds: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    lineheight: 17.72,
    color: AppColors.brown1,
  },
  mmm: {
    flexDirection: "row",
    alignSelf: "flex-end",

    marginHorizontal: 20,
  },
  text: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 14,
    color: AppColors.brown2,
    marginTop: 20,
  },
  activeText: {
    fontFamily: AppFonts.OverpassMedium,
    marginTop: 20,
    fontSize: 14,
    color: AppColors.brown1,
  },
});
